export default __webpack_public_path__ + "static/media/2138.727624c2.png";